var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.706 9.533a1.333 1.333 0 0 0-1.333 0l-4.707 2.32a4 4 0 0 0-4-3.853h-12a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-3.853l4.747 2.373c.182.093.383.143.587.147a1.333 1.333 0 0 0 1.167-.686c.11-.198.167-.421.166-.648V10.667a1.335 1.335 0 0 0-.627-1.134ZM20 20a1.333 1.333 0 0 1-1.334 1.333h-12A1.333 1.333 0 0 1 5.333 20v-8a1.333 1.333 0 0 1 1.333-1.333h12A1.333 1.333 0 0 1 20 12v8Zm6.666-.827-4-2v-2.346l4-2v6.346Z",
    fill: "#fff"
  })));
};
export default SvgVideo;